export const TIKTOK_OVERVIEW_MULTI_BRAND_LEGACY = [
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 0,
    y: 1,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['TIKTOK'],
      metric: 'VIDEO_VIEWS',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 1,
    type: 'HEADER',
    w: 6,
    x: 0,
    y: 0,
    meta: { name: 'All Published Posts' },
  },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 3,
    y: 1,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['TIKTOK'],
      metric: 'NET_NEW_FOLLOWERS',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 0,
    y: 5,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'TIKTOK',
      metric: 'VIDEO_VIEWS',
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'BRAND',
    },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 3,
    y: 5,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'TIKTOK',
      metric: 'ENGAGEMENTS',
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'BRAND',
    },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 0,
    y: 9,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'TIKTOK',
      metric: 'ORGANIC_LIKES',
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'BRAND',
    },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 3,
    y: 9,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'TIKTOK',
      metric: 'ORGANIC_COMMENTS',
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'BRAND',
    },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 0,
    y: 13,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'TIKTOK',
      metric: 'SHARES',
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'BRAND',
    },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 3,
    y: 13,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'TIKTOK',
      metric: 'PROFILE_VIEWS',
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'BRAND',
    },
  },
  {
    h: 1,
    type: 'HEADER',
    w: 6,
    x: 0,
    y: 17,
    meta: { name: 'Posts Published During Reporting Period' },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 0,
    y: 18,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'TIKTOK',
      metric: 'TOTAL_VIDEO_VIEWS',
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'BRAND',
    },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 3,
    y: 18,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'TIKTOK',
      metric: 'TOTAL_ENGAGEMENTS',
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'BRAND',
    },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 0,
    y: 22,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'TIKTOK',
      metric: 'TOTAL_LIKES',
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'BRAND',
    },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 3,
    y: 22,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'TIKTOK',
      metric: 'TOTAL_COMMENTS',
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'BRAND',
    },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 0,
    y: 26,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'TIKTOK',
      metric: 'TOTAL_SHARES',
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'BRAND',
    },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 3,
    y: 26,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'TIKTOK',
      metric: 'NUMBER_OF_POSTS',
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'BRAND',
    },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 0,
    y: 30,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'TIKTOK',
      metric: 'AVG_VIDEO_VIEWS',
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'BRAND',
    },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 3,
    y: 30,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'TIKTOK',
      metric: 'AVG_REACH',
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'BRAND',
    },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 0,
    y: 34,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'TIKTOK',
      metric: 'AVG_ENGAGEMENT_RATE',
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'BRAND',
    },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 3,
    y: 34,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'TIKTOK',
      metric: 'AVG_RETENTION_RATE',
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'BRAND',
    },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 0,
    y: 38,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'TIKTOK',
      metric: 'AVG_ENTERTAINMENT_SCORE',
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'BRAND',
    },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 3,
    y: 38,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'TIKTOK',
      metric: 'AVG_TIME_WATCHED',
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'BRAND',
    },
  },
  {
    h: 4,
    type: 'CONTENT_OWNED',
    w: 6,
    x: 0,
    y: 43,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'TIKTOK',
      metric: 'ENTERTAINMENT_SCORE',
      sort_order: 'DESC',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'CONTENT_OWNED',
    w: 6,
    x: 0,
    y: 47,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'TIKTOK',
      metric: 'TOTAL_VIDEO_VIEWS',
      sort_order: 'DESC',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'CONTENT_OWNED',
    w: 6,
    x: 0,
    y: 51,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'TIKTOK',
      metric: 'TOTAL_VIDEO_VIEWS',
      sort_order: 'ASC',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 1,
    type: 'HEADER',
    w: 6,
    x: 0,
    y: 55,
    meta: { name: 'Follower Activity' },
  },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 0,
    y: 56,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['TIKTOK'],
      metric: 'FOLLOWER_GROWTH_RATE',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 3,
    y: 56,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'TIKTOK',
      metric: 'FOLLOWER_GROWTH_RATE',
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'BRAND',
    },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 0,
    y: 60,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'TIKTOK',
      metric: 'TOTAL_FOLLOWERS',
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'BRAND',
    },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 3,
    y: 60,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'TIKTOK',
      metric: 'NET_NEW_FOLLOWERS',
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'BRAND',
    },
  },
  {
    h: 1,
    type: 'HEADER',
    w: 6,
    x: 0,
    y: 42,
    meta: { name: 'Post Performance' },
  },
];
